<!-- 支付方式选择 -->
<template>
  <van-popup
    v-model="show"
    round
    position="bottom"
    z-index="201"
    class="payment_way_popup"
    :style="{ maxHeight: '85%' }"
    @close="handleClose"
  >
    <div class="payment_way_wrap">
      <div class="payment_way_title van-hairline--bottom">{{title}}</div>
      <div class="payment_way_content">
        <div
          class="payment_way_item van-hairline--bottom"
          :class="item.is_checked ? '' : 'cannot_pick'"
          v-for="item of paymentList"
          :key="item.id"
          @click="handelPickPaymentWay(item)"
        >
          <i
            class="payment_way_icon"
            :class="item.is_checked ? item.icon : `${item.icon} cannot_pay` "
            :style="`color:${item.color}`"
          ></i>
          <div class="payment_name">{{ item.name }}</div>
          <van-icon
            :name="item.label == 'offline_card' && isoffline ? 'arrow-down' : 'arrow'"
            class="payment_check"
            :class="item.is_checked ? '' : 'cannot_pay' "
          />
        </div>

      </div>
      <!-- 线下支付内容 -->
      <div
        v-show="isoffline"
        class="offline_body"
      >
        <div class="cert_upload_wrap">
          <van-uploader
            :before-read="BeforeImgUpload"
            :after-read="UploadImgToServer"
            :class="layout === 'horizontal' ? 'bc_picker_btn_horizontal' : 'bc_picker_btn' "
            :fileList="fileList"
            :before-delete="BeforeImgDelete"
            :max-count="1"
            class="business_card_uploader"
          >
            <div class="bcard_upload_btn">
              <div class="bcard_upload_btn_body">
                <div class="bcard_upload_icon_wrap">
                  <van-icon
                    color="#dcdee0"
                    name="photo"
                    class="bcard_upload_icon"
                  />
                </div>
                <div class="bcard_upload_tips">{{$t('parment.voucher')}}</div>
              </div>
            </div>
          </van-uploader>
        </div>
        <div class="offline_submit_btn_wrap">
          <van-button
            @click="wannaSubmitOffline"
            class="offline_submit_btn"
          >{{$t('parment.submit1')}}</van-button>
        </div>
        <div class="offline_text_wrap">
          <RichText :info="offlinetext" />
        </div>
      </div>
      <div class="payment_btn_wrap">
        <div class="payment_btn_item">
          <van-button
            class="payment_btn payment_cancle"
            round
            @click="handlePaymentBtn('cancle')"
          >{{$t('parment.cancel')}}</van-button>
        </div>
        <div class="payment_btn_item">
          <van-button
            class="payment_btn payment_submit"
            round
            :disabled="submiting"
            @click="handlePaymentBtn('submit')"
          >{{$t('parment.submit2')}}</van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>

import Vue from 'vue'
import {
  Popup,
  Uploader,
  Button
} from 'vant'
Vue.use(Popup)
Vue.use(Uploader)
Vue.use(Button)

import RichText from '@c/RichText'

import { UploadAuthentication } from '@a/js/api/public'
import { UploadYun } from '@a/js/api/uploadyun'
import apiObj from '@a/js/api.js'
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    },
    show: {
      type: Boolean,
      default: false,
    },
    payment: {
      type: Array,
      default: () => ([])
    },
    submiting: {
      type: Boolean,
      default: false
    },
    offlinetext: {
      type: String,
      default: ''
    },
    layout: {
      type: String,
      default: 'horizontal'
    },
    isuploadcert: {
      type: Boolean,
      default: false
    }
  },
  name: 'PaymentWay',
  data() {
    return {
      params: {},
      paymentArr: [
        {
          id: 'wxpay',
          name: '',
          label: 'wxpay_jsapi',
          icon: 'ri-wechat-pay-fill',
          color: '#19be6b',
          is_checked: false,
        },
        {
          id: 'alipay',
          name: '',
          label: 'alipay_wappay',
          icon: 'ri-alipay-fill',
          color: '#0291ff',
          is_checked: false,
        },
        // {
        //   id: 'unionpay',
        //   name: '银联支付（信用卡）',
        //   label: 'unionpay',
        //   icon: 'ri-bank-card-fill',
        //   color: '#dd2c34',
        //   is_checked: false,
        // },
        {
          id: 'paypal',
          name: '',
          label: 'paypal_checkout',
          icon: 'ri-paypal-fill',
          color: '#0569cc',
          is_checked: false,
        },
        {
          id: 'offline',
          name: '',
          label: 'offline_card',
          icon: 'ri-exchange-cny-fill',
          // icon: 'ri-exchange-cny-line',
          color: '#ff9900',
          is_checked: false,
        },
      ],
      // paymentList: [],
      paymentWay: '',
      hasInit: false,
      isoffline: false,
      certImg: ''
    };
  },

  components: {
    RichText
  },

  computed: {
    paymentList() {
      let arr = []
      this.paymentArr.map(item => {
        if (this.payment.indexOf(item.id) != -1) {
          item.is_checked = true
        } else {
          item.is_checked = false
        }
        if (item.id == 'wxpay' && !this.judgeIsWeiXin()) {
          item.is_checked = false
        }
        item.name = this.$t(`parment.${item.id}`)
        arr.push(item)
      })

      return arr

    },
    fileList() {
      let arr = []
      if (this.certImg.length) {
        arr.push({
          url: apiObj.VUE_APP_BASE_CDN + this.certImg
          // url: apiObj.VUE_APP_BASE_CDN + this.certImg + '!/fh/120'
        })
      }
      return arr
    }
  },

  methods: {
    // 判断是否微信浏览器
    judgeIsWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        resolve();
      });
    },
    // 关闭支付方式选择
    handleClose() {
      this.$emit('listenClosePickPaymentMethod')
    },
    // 选择支付方式
    handelPickPaymentWay(data) {
      if (data.is_checked) {
        if (data.label == 'offline_card') {
          this.isoffline = true
        } else {
          this.isoffline = false
          this.$emit('listenPickedPaymentWay', data.label, '')
        }

      } else if (data.id == 'wxpay' && this.payment.indexOf('wxpay') != -1 && !this.judgeIsWeiXin()) {
        this.$notify({
          type: 'warning',
          message: this.$t('notify.browserTip'),
        })
      }
    },

    // 操作支付选择结果
    handlePaymentBtn(type) {
      if (type === 'cancle') {
        this.$emit('listenClosePickPaymentMethod')
      } else {
        this.hasInit = false
        this.$emit('listenWannaSubmitOrder', this.paymentWay)
        this.$emit('listenClosePickPaymentMethod')

      }
    },
    // 判断是否返回门票选择页面
    checkIsNeedToHide() {
      let pageName = this.$route.name
      if (pageName === 'Ticket') {
        this.$emit('listenClosePickPaymentMethod')
      }
    },
    //文件校验
    BeforeImgUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'

      if (!(isJPG || isPNG)) {
        this.$notify({
          type: 'warning',
          message: this.$t('notify.uploadImg'),
        })
      }
      const isLt2M = file.size / 1024 / 1024 < 15
      if (!isLt2M) {
        this.$notify({
          type: 'warning',
          message: this.$t('notify.uploadSize15'),
        })
      }
      return (isJPG || isPNG) && isLt2M
    },
    // 上传图片到服务器
    UploadImgToServer(data) {
      let file = new File([data.file], (new Date()).getTime() + '_' + data.file.name, { type: data.file.type })
      this.BeforeUploadAuth(file)
    },
    // 文件上传前鉴权
    BeforeUploadAuth(file) {
      let resdata = {
        module: 'business',
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        path: '/booking/cert/' + file.name,
      }
      UploadAuthentication(resdata)
        .then((res) => {
          file.status = 'uploading'
          const formData = new FormData()
          formData.append('file', file)
          formData.append('policy', res.data.policy)
          formData.append('authorization', res.data.authorization)
          UploadYun(formData)
            .then((res) => {
              // file.status = 'done'
              this.certImg = res.url
              this.$notify({
                type: 'success',
                message: this.$t('notify.uploadSuc'),
              })
            })
            .catch(() => {
              file.status = 'failed'
            })
        })
        .catch(() => {
          file.status = 'failed'
        })
    },
    // 删除凭证
    BeforeImgDelete() {
      this.certImg = ''
    },
    // 点击提交线下支付订单
    wannaSubmitOffline() {
      if (this.isuploadcert) {
        if (this.certImg.length) {
          this.$emit('listenPickedPaymentWay', 'offline_card', this.certImg)
        } else {
          this.$notify({
            type: 'warning',
            message: this.$t('notify.payVoucher'),
          })
        }
      } else {
        this.$emit('listenPickedPaymentWay', 'offline_card', this.certImg)
      }
    }
  },

  mounted() {
    this.GetParamsData()
  },
}
</script>
<style lang='less' scoped>
.payment_way_popup {
  z-index: 202 !important;
}
.payment_way_wrap {
  // min-height: 360px;
  // display: flex;
  // flex-direction: column;
  .payment_way_title {
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    padding: 15px 40px;
    letter-spacing: 1px;
    font-weight: bold;
    display: none;
  }
  .payment_way_content {
    padding: 10px 15px;
    // min-height: 220px;
    .payment_way_item {
      display: flex;
      height: 50px;
      line-height: 50px;
      .payment_way_icon {
        margin-right: 8px;
        font-size: 24px;
        color: #19be6b;
      }
      .cannot_pay {
        color: #ccc !important;
      }
      .payment_name {
        font-size: 14px;
        letter-spacing: 1px;
        flex: 1;
      }
      .payment_check {
        font-size: 24px;
        line-height: 50px;
        color: var(--background);
      }
    }
    .cannot_pick {
      color: #ccc;
    }
  }
  .offline_body {
    padding: 0 15px;
    padding-bottom: 15px;
    margin-bottom: 60px;
    .cert_upload_wrap {
      margin-bottom: 10px;
      .business_card_uploader {
        width: 100%;
        position: relative;
      }
      :v-deep .van-uploader__upload {
        margin: 0;
      }
      :v-deep .van-uploader__input-wrapper {
        width: 100%;
      }
      :v-deep .van-uploader__preview {
        margin: 0;
        border-radius: 4px !important;
        background: #f7f8fa;
        width: 100%;
        padding: 5px 0;
      }
      :v-deep .van-uploader__preview-image {
        max-width: 98%;
        width: fit-content;
        margin: 0 auto;
        height: 130px;
      }
      :v-deep .van-image__img {
        width: auto;
      }
      .bcard_upload_btn {
        width: 100%;
        min-height: 140px;
        background: #f7f8fa;
        border-radius: 4px;
        display: flex;
        align-items: center;
        .bcard_upload_btn_body {
          margin: 0 auto;
          padding: 15px;
          text-align: center;
          .bcard_upload_icon {
            font-size: 40px;
          }
          .bcard_upload_tips {
            font-size: 14px;
            line-height: 1.2;
            text-align: justify;
            color: #999;
          }
        }
      }
    }
    .offline_submit_btn_wrap {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      box-sizing: border-box;
      background: #fff;
      display: flex;
      z-index: 10;
      box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
    }
    .offline_submit_btn {
      background: var(--background);
      color: var(--color);
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      font-weight: 700;
      letter-spacing: 0.01em;
    }
    .offline_text_wrap {
      font-size: 14px;
    }
  }
  .payment_btn_wrap {
    padding: 15px 0;
    display: flex;
    box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
    display: none;
    .payment_btn_item {
      flex: 1;
      text-align: center;
      .payment_btn {
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        width: 160px;
        letter-spacing: 1px;
      }
      .payment_cancle {
        color: #999;
        border-color: #999;
      }
      .payment_submit {
        background-color: var(--background);
        border-color: var(--background);
        color: var(--fontColor);
      }
    }
  }
}
</style>